export const orderReport = {
	title: "Relatório de pedidos",
	sheet: {
		filename: "vendor-delivery-report",
		title: "Vendas Delivery",
		columns: {
			chanel: "Plataforma",
			reference: "Nº do pedido",
			date: "Data e hora",
			obs: "OBS",
			status: "Estado",
			paymentMethods: "Métodos de pagamento",
			customerName: "Cliente",
			customerPhone: "Telefone Cliente",
			vendor: "Vendor",
			value: "Valor",
			deliveryFee: "Taxa de entrega",
			tip: "Gorjeta",
			discount: "Desconto",
			subtotal: "Subtotal",
		},
	},
	columns: {
		chanel: "Plataforma",
		reference: "Nº do pedido",
		date: "Data e hora",
		obs: "OBS",
		status: "Estado",
		paymentMethods: "Métodos de pagamento",
		customerName: "Cliente",
		customerPhone: "Telefone Cliente",
		vendor: "Vendor",
		value: "Valor",
		deliveryFee: "Taxa de entrega",
		tip: "Gorjeta",
		discount: "Desconto",
		subtotal: "Sub Total",
	},
	vendorLabels: {
		coala: "Whitelabel",
		ifood: "Ifood",
		rappi: "Rappi",
		ubereats: "Uber Eats",
	},
	methodsLabel: {
		creditCard: "Cartão de crédito",
		debitCard: "Cartão de débito",
		cash: "Dinheiro",
		creditCardOnline: "Cartão de cŕedito online",
		voucherInPlace: "Voucher",
		mastercard: "Master-card",
		visa: "Visa",
		amex: "Amex",
		elo: "Elo",
		hipercard: "Hiper-card",
		diners: "Diners",
		ticket: "Ticket",
		alelo: "Alelo",
		vr: "VR",
		ben: "Ben",
		sodexo: "Sodexo",
	},
	statusLabel: {
		ready: "Pronto",
		canceled: "Cancelado",
		concluded: "Concluído",
		confirmed: "Confirmado",
		dispatched: "Despachado",
		integrated: "Integrado",
		placed: "Criado",
		pendingPayment: "Pagamento pendente",
		pickupAreAssigned: "Cliente no local",
		scheduled: "Agendado",
	},
	channelLabel: {
		marketplace: "Marketplace",
		phone: "Telefone",
		whatsapp: "Whatsapp",
		whitelabel: "Whitelabel",
	},
};
